import React, { memo } from 'react';
import { reduxForm } from 'redux-form';
import { func, bool, string } from 'prop-types';
import Radium from 'radium';
import { handleKeyDown } from '@widergy/utilitygo-forms-web';
import { UTButton } from '@widergy/energy-ui';

import { appConfig } from 'config/customization';
import { genderField, documentNumberField, documentTypeField } from 'constants/fields';
import UTForm from 'app/components/UTForm';
import { message } from 'utils/stringUtils';
import { USER_PAYMENT_DOCS } from 'constants/reduxForms';

import stylesJS from './styles';
import styles from './styles.module.scss';

const UserPaymentDocsForm = ({ documentType, documentNumber, submitFailed, invalid, handleSubmit }) => {
  const gender =
    appConfig.signIn.conditionalRequestGender &&
    documentType === 'dni' &&
    documentNumber >= appConfig.signIn.minDocNumber &&
    documentNumber <= appConfig.signIn.maxDocNumber
      ? [genderField]
      : [];

  const fields = [documentTypeField, documentNumberField, ...gender];

  const fieldValues = { document_number: documentNumber, document_type: documentType };

  return (
    <form onKeyDown={handleKeyDown(handleSubmit)} onSubmit={handleSubmit} style={stylesJS.form}>
      <div style={stylesJS.userDataContainer}>
        <UTForm fields={fields} fieldValues={fieldValues} formClasses={{ formContainer: styles.form }} />
      </div>
      {appConfig.allowPaymentDocumentSelection && (
        <UTButton disabled={submitFailed && invalid} type="submit" style={stylesJS.button}>
          {message('PublicPayment:getCoupon')}
        </UTButton>
      )}
    </form>
  );
};

UserPaymentDocsForm.propTypes = {
  submitFailed: bool,
  invalid: bool,
  handleSubmit: func.isRequired,
  documentType: string,
  documentNumber: string
};

export default reduxForm({ form: USER_PAYMENT_DOCS })(memo(Radium(UserPaymentDocsForm)));
